"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "UserFacingError", {
    enumerable: true,
    get: function() {
        return UserFacingError;
    }
});
class UserFacingError extends Error {
    statusCode;
    constructor(message, statusCode){
        super(message);
        this.name = this.constructor.name;
        this.statusCode = statusCode;
    }
    getUserFacingError() {
        return this.message;
    }
    getStatusCode() {
        return this.statusCode;
    }
}
